import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { TransactionCount, TransactionCountByMonth } from './types'

export const transactionsMounted = createEvent()

export const getTransactionCount = fx<void, TransactionCount>({
  method: 'GET',
  url: '/transaction_request/count',
})

export const getTransactionCountByMonth = fx<void, TransactionCountByMonth[]>({
  method: 'GET',
  url: '/transaction_request/count-by-month',
})

export const $transactionCount = restore<TransactionCount>(
  getTransactionCount.doneData.map((a) => a.body),
  { count: 0 },
)

export const $transactionCountByMonth = restore<TransactionCountByMonth[]>(
  getTransactionCountByMonth.doneData.map((a) => a.body),
  [],
)

sample({
  clock: transactionsMounted,
  fn: () => ({}),
  target: getTransactionCount,
})

sample({
  clock: transactionsMounted,
  fn: () => ({}),
  target: getTransactionCountByMonth,
})
